@if (isModalActive) {
  <div class="modal-header">
    <h3 class="modal-title fkm-modal-title" id="modal-title">{{texts.minaMaskinlag}}</h3>
    <button type="button" class="btn-close" (click)="dismiss()"></button>
  </div>
}

<rask-page [pageTitle]="isModalActive ? '' : texts.minaMaskinlag" [footerShow]="!isModalActive" [contentShow]="false">
  <ng-container headerContent>
    @if (maskinlagLoaded) {
      <form id="maskinlagForm" [formGroup]="form" class="form col-12 p-0">
        <div class="mrrs-panel">
          <rask-multi-range-select
            aid="selectorMinaMaskinlag"
            formControlName="minaMaskinlag"
            name="selectedMaskinlag"
            [items]="allaMaskinlag"
            [itemsTitle]="texts.samtligaMaskinlag"
            [valueTitle]="texts.minaMaskinlag"
            [orderItemsBy]="orderByCsr"
            [viewFormatter]="listDisplayName"
            [allowValueSort]="true"
            [size]="15">
          </rask-multi-range-select>
        </div>
        <div class="align-right">
          @if (isModalActive) {
            <rask-button class="maskinlag-save-button" (click)="save()" [disabled]="!maskinlagUpdated">Spara</rask-button>
          }
        </div>
      </form>
    }
  </ng-container>
  <ng-container footerContent>
    <rask-save-button class="maskinlag-save-button" form="maskinlagForm" (click)="save()" [disabled]="!maskinlagUpdated"></rask-save-button>
  </ng-container>
</rask-page>
